export default __webpack_public_path__ + "static/media/icon13.7235b6f7.svg";